<template>
<div>
  <div class="row wrap" v-if="type.role != 'ambassador'">
    <div class="col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3">
      <div v-if="activeComponent == null" class="form-group event-buttons-group">
        <transition name="fade" appear>
          <fieldset>
            <legend class="hidden-xs">Choisir une action :
              <button v-if="type.type != 'solo'" id="btnGraph" class="btn pull-right" @click="displayGraph()"><i class="fas fa-chart-bar"></i></button>
              <VueCtkDateTimePicker class="pull-right" no-value-to-custom-elem format="YYYY-MM-DD" only-date auto-close color="#70A6B2" no-button-now style="display: inline; width: 26rem" @input="gotoDate">
                <button class="btn pull-right"><i class="far fa-calendar-alt"></i></button>
              </VueCtkDateTimePicker>
            </legend>
            <div class="row wrap no-gutter">
              <div v-if="type.type != 'solo'" class="col-xxs-5 col-xs-4 col-sm-3" style="margin-bottom: 0.5rem">
                <button class="btn btn-block btnBooking" @click="openComponent('bookingMultiple','Créer une collective')">
                  <i class="fas fa-plus"></i> Collective
                </button>
              </div>
              <div class="col-xxs-5 col-xs-4 col-sm-3" style="margin-bottom: 0.5rem">
                <button class="btn btn-block btnBooking" @click="openComponent('booking','Créer un engagement')">
                  <i class="fas fa-plus"></i> Engagement
                </button>
              </div>
              <div class="col-xxs-2 col-xs-1 visible-xs" style="z-index: 9999 !important">
                <VueCtkDateTimePicker no-value-to-custom-elem format="YYYY-MM-DD" only-date auto-close color="#70A6B2" no-button-now @input="$emit('goto-date')">
                  <button class="btn btn-block"><i class="far fa-calendar-alt"></i></button>
                </VueCtkDateTimePicker>
              </div>
              <div class="col-sm-3 col-sm-offset-0 hidden-xs" v-bind:class="{ 'col-sm-offset-6': type.type == 'solo' }" style="margin-bottom: 0.5rem">
                <button class="btn btn-block blue" @click="openComponent('event','Créer un événement')">
                  <i class="fas fa-plus"></i> Evénement
                </button>
              </div>
              <div v-show="type.type != 'solo'" class="col-xxs-12 col-xs-3 col-sm-3">
                <a id="currentdayevents-btn" target="_blank" class="btn blue btn-block btn-right" @click="currentdayevents($event)">
                  <i class="far fa-file-pdf"></i> RDV du jour
                </a>
              </div>
            </div>
          </fieldset>
        </transition>
      </div>
      <div v-if="activeComponent == 'booking'">
        <transition name="fade" appear>
          <calBooking
            :users="users"
            :renforts="renforts"
            :activities="activities"
            :current="selectedEvent"
            :booking="booking"
            :userType="type"
            :legend="legend"
            :quickCreate="quickCreate"
            :redirectbillingroute="redirectbillingroute"
            :permissions="permissions"
            :has-stripe="hasStripe"
            @snotify="snotify"
            @refetch-events="refetchEvents"
            @close="closeComponent"
          ></calBooking>
        </transition>
      </div>
      <div v-if="activeComponent == 'bookingMultiple'">
        <transition name="fade" appear>
          <calBookingMultiple
            :current="selectedEvent"
            :legend="legend"
            :booking-multiple="bookingMultiple"
            :activities="activities"
            @edit-booking-multiple-group="openComponent('bookingMultipleGroup')"
            @snotify="snotify"
            @refetch-events="refetchEvents"
            @close="closeComponent"
          ></calBookingMultiple>
        </transition>
      </div>
      <div v-if="activeComponent == 'bookingMultipleGroup'">
        <transition name="fade" appear>
          <calBookingMultipleGroup
            :current="selectedEvent"
            :booking="bookingMultiple"
            :legend="legend"
            :users="users"
            :renforts="renforts"
            :quickCreate="quickCreate"
            :redirectbillingroute="redirectbillingroute"
            @edit-booking-multiple="openComponent('bookingMultiple')"
            @snotify="snotify"
            @refetch-events="refetchEvents"
            @close="closeComponent"
          ></calBookingMultipleGroup>
        </transition>
      </div>
      <div v-if="activeComponent == 'event'">
        <transition name="fade" appear>
          <calEvent
            :users="users"
            :legend="legend"
            :current="selectedEvent"
            :renforts="renforts"
            @snotify="snotify"
            @refetch-events="refetchEvents"
            @close="closeComponent"
          ></calEvent>
        </transition>
      </div>
    </div>
    <cal-graph v-if="type.type != 'solo'" ref="calGraph"></cal-graph>
  </div>
  <calendar ref="calendar" :renforts="renforts" :users="users" :type="type" @event-click="handleEventClick" @select="handleSelect"></calendar>
</div>
</template>
<style>
@media (max-width: 991px){
  .fc .fc-toolbar.fc-header-toolbar{
    margin-bottom: 0!important;
  }
  .event-buttons-group{
    margin-bottom: 0
  }
  .no-gutter>[class*="col-"] {
    padding-right: 5px;
    padding-left: 5px;
  }
  @media (max-width: 576px){
    .col-xxs-2{width: 16.66667%;}
    .col-xxs-5{width: 41.66667%;}
    .col-xxs-12{width: 100%;}
  }
}
</style>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import moment from 'moment';
moment.locale('fr');

export default {
  components: {
    VueCtkDateTimePicker
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    renforts: {
      type: Array,
      default: () => []
    },
    type:{
      type: Object,
      default: () => []
    },
    activities: {
      type: Array,
      default: () => []
    },
    redirectbillingroute: String,
    permissions: {
      type: Array,
      default: () => []
    },
    hasStripe: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedEvent:{},
      booking: {},
      bookingMultiple:{},
      activeComponent: null,
      legend: '',
      quickCreate: false,
    }
  },
  created:function(){
    this.reset();//init data
  },
  methods:{
    gotoDate(date){
      this.$refs.calendar.getApi().gotoDate(date)
    },
    refetchEvents(){
      this.$refs.calendar.getApi().refetchEvents()
    },
    displayGraph(){
      this.$refs.calGraph.loadGraph()
    },
    openComponent(component, legend){
      this.activeComponent = component
      this.legend = legend
    },
    closeComponent(){
      this.reset()
      this.activeComponent=null
    },
    reset() {
      this.booking = {
        activity: {},
        activities:[],
        provider: '',
        renfortId: '',
        id: '',
        title: '',
        rdv: '',
        published_at: '',
        selectedCustomer: {},
        comments: '',
        isPaid: false,
        eventStart: '',
        eventEnd: '',
        payment: '',
        has_billing: '',
        isPaid: false,
        payment: ''
      }
      this.bookingMultiple={
        eventId:'',
        total_places:0,
        comment:'',
        groups:[]
      }
      this.selectedEvent = {
        eventTitle: '',
        eventStart: '',
        eventEnd: '',
        //eventId: 0,
        color: '#1FBC9C',
        userId: '',
        renfortId: '',
        meeting_point:''
      }
      this.legend = 'Choisir une action :'
      this.quickCreate = false
    },
    snotify() {
      this.$snotify.success('Calendrier mis à jour')
    },
    currentdayevents(e){
      let date = moment(this.$refs.calendar.getApi().getDate()).format('YYYY-MM-DD')
      $("#currentdayevents-btn").attr("href",'calendar/event/currentdayevents/'+date)
    },
    handleEventClick(eventClickInfo ){
      this.closeComponent()//close previously open component before opening a new one
      if(eventClickInfo.event.classNames.includes('other-office')){//cannot edit 'false' background event
        return;
      }
      let evt = eventClickInfo.event;
      if (evt.end === null) {
        evt.end = evt.start
      }
    
      this.selectedEvent.eventTitle = evt.title;
      this.selectedEvent.eventShortTitle = evt.extendedProps.shortTitle;
      this.selectedEvent.eventStart = moment(evt.start).format('YYYY-MM-DD HH:mm:ss')
      this.selectedEvent.eventEnd = moment(evt.end).format('YYYY-MM-DD HH:mm:ss')
      this.selectedEvent.eventId = evt.id
      this.selectedEvent.color = evt.backgroundColor
      this.selectedEvent.userId = evt.extendedProps.userId
      this.selectedEvent.renfortId = evt.extendedProps.renfortId
      this.selectedEvent.usersIds = evt.extendedProps.usersIds
      this.selectedEvent.renfortsIds = evt.extendedProps.renfortsIds
      this.selectedEvent.meeting_point = evt.extendedProps.meeting_point
      this.selectedEvent.activity = evt.extendedProps.activity.id
      
      this.booking.id = evt.extendedProps.booking.id
      this.booking.title = evt.title
      this.booking.eventStart = moment(evt.start).format('YYYY-MM-DD HH:mm:ss')
      this.booking.eventEnd = moment(evt.end).format('YYYY-MM-DD HH:mm:ss')
      this.booking.eventId = evt.id
      this.booking.provider = evt.extendedProps.userId
      this.booking.renfortId = evt.extendedProps.renfortId
      this.booking.selectedCustomer = (evt.extendedProps.booking!=null)?evt.extendedProps.booking.customer:null
      this.booking.activity = evt.extendedProps.activity.id
      this.booking.activities = evt.extendedProps.booking.activities
      this.booking.comments = evt.extendedProps.booking.message
      this.booking.rdv = evt.extendedProps.meeting_point
      this.booking.published_at = evt.extendedProps.booking.published_at
      this.booking.has_billing = evt.extendedProps.booking.has_billing
      this.booking.isPaid = evt.extendedProps.booking.is_paid
      this.booking.payment = evt.extendedProps.booking.payment_method
      this.booking.booking_invitations = evt.extendedProps.booking.booking_invitations

      this.bookingMultiple.id = evt.extendedProps.bookingMultiple.id
      this.bookingMultiple.eventId=evt.extendedProps.bookingMultiple.event_id
      this.bookingMultiple.total_places=evt.extendedProps.bookingMultiple.total_places
      this.bookingMultiple.comment=evt.extendedProps.bookingMultiple.comment
      this.bookingMultiple.groups = evt.extendedProps.bookingMultiple.groups
      
      if(evt.extendedProps.bookingMultiple && Object.keys(evt.extendedProps.bookingMultiple).length !==0){//bookingMultiple
        this.openComponent('bookingMultipleGroup','Remplir une collective')
      }else if (this.booking.selectedCustomer && Object.keys(this.booking.selectedCustomer).length != 0){//booking
        this.openComponent('booking','Modifier un engagement')
      }else{//event
        this.openComponent('event','Modifier un événement')
      }
    },
    handleSelect(selectionInfo){
      this.closeComponent()//close previously open component before opening a new one
      this.selectedEvent.eventStart = selectionInfo.start
      this.selectedEvent.eventEnd = selectionInfo.end
      this.booking.eventStart = moment(selectionInfo.start).format('YYYY-MM-DD HH:mm:ss')
      this.booking.eventEnd = moment(selectionInfo.end).format('YYYY-MM-DD HH:mm:ss')

      if (selectionInfo.resource) {
        selectionInfo.resource.extendedProps.type === 'user' ? this.selectedEvent.userId = selectionInfo.resource.extendedProps.resourceId : this.selectedEvent.renfortId = selectionInfo.resource.extendedProps.resourceId
        this.quickCreate = true
      } else {
        this.quickCreate = false
      }
      this.openComponent("booking","Créer un engagement")
    }
  }
}
</script>